var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mp-services"
  }, [_c('h2', {
    staticClass: "mp-services__title"
  }, [_vm._v("Наши сервисы")]), _vm._v(" "), _c('div', {
    staticClass: "mp-services__content"
  }, _vm._l(_vm.services, function (service) {
    return _c('GGLink', {
      key: service.index,
      attrs: {
        "to": service.path
      }
    }, [_c('div', {
      staticClass: "mp-services__service-card",
      class: ("mp-services__service-card_" + (service.index))
    }, [_c('p', {
      staticClass: "service-card__title"
    }, [_vm._v("\n          " + _vm._s(service.name) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(service.desc) + "\n        ")])])]);
  }), 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }